const steps = [
  {
    num: "01",
    title: "Anfrage senden",
    text: "Schritt für Schritt und mit klaren nächsten Schritten.",
  },
  {
    num: "02",
    title: "Bedarf besprechen",
    text: "Wir klären Umfang, Ort und Zeitfenster – ohne Druck.",
  },
  {
    num: "03",
    title: "Offerte erhalten",
    text: "Sie erhalten eine Offerte, die zu Ihrem Bedarf passt.",
  },
  {
    num: "04",
    title: "Service durchführen",
    text: "Unser Team führt den Auftrag zuverlässig aus.",
  },
];

export default steps;